"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagTypes = exports.TagSizes = exports.IconTypes = void 0;

var _designLanguage = require("@doordash/design-language");

var IconTypes = _designLanguage.Icon.Types;
exports.IconTypes = IconTypes;
var TagSizes;
exports.TagSizes = TagSizes;

(function (TagSizes) {
  TagSizes["Small"] = "Small";
  TagSizes["Medium"] = "Medium";
  TagSizes["Large"] = "Large";
})(TagSizes || (exports.TagSizes = TagSizes = {}));

var TagTypes; // To Do (lindsey-menges):
// properly type `textProps` when Text has fleshed out
// type definitions

exports.TagTypes = TagTypes;

(function (TagTypes) {
  TagTypes["HighlightDefault"] = "HighlightDefault";
  TagTypes["HighlightEmphasis"] = "HighlightEmphasis";
  TagTypes["InformationalDefault"] = "InformationalDefault";
  TagTypes["InformationalEmphasis"] = "InformationalEmphasis";
  TagTypes["NegativeDefault"] = "NegativeDefault";
  TagTypes["NegativeEmphasis"] = "NegativeEmphasis";
  TagTypes["PositiveDefault"] = "PositiveDefault";
  TagTypes["PositiveEmphasis"] = "PositiveEmphasis";
  TagTypes["WarningDefault"] = "WarningDefault";
  TagTypes["WarningEmphasis"] = "WarningEmphasis";
})(TagTypes || (exports.TagTypes = TagTypes = {}));